module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "commentPanel"
  }, [_c('Loader', {
    attrs: {
      "loading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "headerPanel"
  }, [_c('p', [_vm._v("\n            " + _vm._s(_vm.$t("commentPanel.title")) + "\n            "), _c('span', {
    staticClass: "commentCount",
    class: [_vm.inPanel ? 'pointer' : ''],
    on: {
      "click": _vm.openCommentsModal
    }
  }, [_vm._v(" " + _vm._s(_vm.commentsLength) + " ")]), _vm._v(" "), (_vm.inPanel && _vm.commentsLength > 0) ? _c('span', {
    staticClass: "openPanel fright pointer",
    on: {
      "click": _vm.togglePanel
    }
  }, [_vm._v("v")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "panelBody"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.minimisePanel),
      expression: "minimisePanel"
    }],
    staticClass: "comments",
    class: [_vm.inPanel ? '' : 'modalComment']
  }, [_vm._l((_vm.personalNotes), function(comment) {
    return _c('CommentBox', {
      key: comment.id,
      attrs: {
        "comment": comment
      }
    })
  }), _vm._v(" "), _vm._l((_vm.comments), function(comment) {
    return _c('CommentBox', {
      key: comment.id,
      attrs: {
        "comment": comment
      }
    })
  })], 2), _vm._v(" "), (_vm.inPanel && _vm.commentsLength > 0) ? _c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.minimisePanel),
      expression: "minimisePanel"
    }],
    staticClass: "allComments",
    on: {
      "click": _vm.openCommentsModal
    }
  }, [_vm._v(_vm._s(_vm.$t("commentPanel.allComments")))]) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newComment),
      expression: "newComment"
    }],
    staticClass: "newComment",
    attrs: {
      "placeholder": _vm.$t('commentPanel.newCommentPh')
    },
    domProps: {
      "value": (_vm.newComment)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newComment = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.inPanel) ? _c('div', {
    staticClass: "commentFooter fright"
  }, [_c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.saveComment(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("commentPanel.addPersonalNote")))]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    on: {
      "click": function($event) {
        _vm.saveComment(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("commentPanel.addComment")))])]) : _c('div', {
    staticClass: "commentFooter fright"
  }, [_c('ClientColorButton', {
    attrs: {
      "disabled": !_vm.canSave
    },
    on: {
      "click": function($event) {
        _vm.saveComment(true);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("commentPanel.addPersonalNote")))]), _vm._v(" "), _c('ClientColorButton', {
    attrs: {
      "disabled": !_vm.canSave
    },
    on: {
      "click": function($event) {
        _vm.saveComment(false);
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("commentPanel.addComment")))])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ad9228fe","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CommentBloc/CommentPanel.vue
// module id = 3345
// module chunks = 0